<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-sys__productpricing}">
      <el-form
        :inline="true"
        :model="dataForm"
        @keyup.enter.native="getDataList()"
      >
        <el-form-item>
          <el-date-picker
            v-model="dataForm.effectiveDate"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="生效日期"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item>
          <wCity v-model="dataForm.city" defaultUrl="/sys/productpricing/accessToAccess" placeholder="城市"></wCity>
          <!-- <sclect-city v-model="dataForm.city" ></sclect-city> -->
        </el-form-item>
        <el-form-item>
          <renSelect
            v-model="dataForm.product"
            placeholder="产品"
            originPage="put"
            dictType="loan_type"
          ></renSelect>
        </el-form-item>

        <el-form-item>
          <el-button @click="getDataList()">{{ $t("query") }}</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
        </el-form-item> -->
        <el-form-item>
          <el-button type="primary" v-if="$hasPermission('sys:productpricing:save')" @click="addOrUpdateHandle()">{{
            $t("add")
          }}</el-button>
        </el-form-item>
      </el-form>
      <div class="messageText">
        <span>TIPS</span
        >：00:00-17:00（不包括17:00）新增、修改或复核过的定价，次日生效；17:00-24:00新增、修改或复核过的定价，次次日生效。
      </div>
      <el-table
        v-loading="dataListLoading"
        :data="dataList"
        border
        @selection-change="dataListSelectionChangeHandle"
        style="width: 100%"
        @sort-change="dataListSortChangeHandle($event,false)"
      >
        <!-- <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column> -->

        <el-table-column
          prop="city"
          label="城市"
          header-align="center"
          align="center"
          sortable="custom"
        ></el-table-column>
        <el-table-column
          prop="productName"
          label="产品"
          header-align="center"
          align="center"
       
        ></el-table-column>

        <el-table-column
          prop="productPricing"
          label="定价(元/个)"
          header-align="center"
          align="center"
          sortable="custom"
        ></el-table-column>
        <el-table-column
          prop="effectiveDate"
          label="生效日期"
          header-align="center"
          align="center"
          sortable="custom"
        >
        <template slot-scope="scope">
          <div>
            {{scope.row.effectiveDate.split(' ')[0]}}
          </div>
        </template>
      </el-table-column>

        <el-table-column
          prop="reviewersStatus"
          label="状态"
          header-align="center"
          align="center"
          sortable="custom"
        >
          <template slot-scope="scope">
            <div>
              <span v-if="scope.row.reviewersStatus == 0">待审核</span>
              <span v-if="scope.row.reviewersStatus == 1">审核通过</span>
              <span v-if="scope.row.reviewersStatus == 2">待修改</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="status"
          label="是否有效"
          header-align="center"
          align="center"
          sortable="custom"
        >
          <template slot-scope="scope">
            <div>
              <span v-if="scope.row.status == 0">无效</span>
              <span v-if="scope.row.status == 1">有效</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="createDate"
          label="录入时间"
          header-align="center"
          align="center"
          sortable="custom"
        ></el-table-column>
        <el-table-column
          prop="updateTime"
          label="修改时间"
          header-align="center"
          align="center"
          sortable="custom"
        ></el-table-column>
        <el-table-column
          prop="reviewersDate"
          label="复核时间"
          header-align="center"
          align="center"
          sortable="custom"
        ></el-table-column>
        <el-table-column
          prop="creatorName"
          label="录入人"
          header-align="center"
          align="center"
       
        ></el-table-column>
        <el-table-column
          prop="reviewersName"
          label="复核人"
          header-align="center"
          align="center"
         
        ></el-table-column>
        <el-table-column
          :label="$t('handle')"
          fixed="right"
          header-align="center"
          align="center"
          width="150"
        
        >
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.reviewersStatus == 0 && $hasPermission('sys:productpricing:audit')"
              type="text"
              size="small"
              @click="
                editStatussocped(scope.row, '/sys/productpricing/audit', 1)
              "
              >通过</el-button
            >
            <el-button
              v-if="scope.row.reviewersStatus == 0 && $hasPermission('sys:productpricing:audit')"
              type="text"
              size="small"
              @click="
                editStatussocped(scope.row, '/sys/productpricing/audit', 2)
              "
              >不通过</el-button
            >

            <el-button
              v-if="scope.row.reviewersStatus == 2 && $hasPermission('sys:productpricing:update')"
              type="text"
              size="small"
              @click="addOrUpdateHandle(scope.row.id)"
              >{{ $t("update") }}</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle"
      >
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update
        v-if="addOrUpdateVisible"
        ref="addOrUpdate"
        @refreshDataList="getDataList"
      ></add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from "@/mixins/view-module";
import AddOrUpdate from "./productpricing-add-or-update";
import city from "../../../components/my-city/city.vue";
import renSelect from "../../../components/ren-select";
export default {
  mixins: [mixinViewModule],
  data() {
    return {
      mixinViewModuleOptions: {
        getDataListURL: "/sys/productpricing/page",
        getDataListIsPage: true,
        exportURL: "/sys/productpricing/export",
        deleteURL: "/sys/productpricing",
        deleteIsBatch: true,
      },

      dataForm: {
        effectiveDate: "",
        city: "",
        product: "",
      },
    };
  },
  mounted() {
    this.getTime();
  },
  methods: {
    getTime() {
      let date = new Date();
      let y = date.getFullYear();
      let m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      const time = y + "-" + m + "-" + d;
      // this.dataForm.dwqdDate = time;
      console.log(this.dataForm.dwqdDate);
    },
    // 修改状态
    editStatussocped(params, url, status) {
      if (status == 1) {
        if(this.isNextDayAfter5pm()){
        this.$message.warning(
         '17:00(含）后定价设置次次日生效，当前日期'+ this.getDateWithOffsetDays(0) +
         '生效日期将改为'+
         this.getDateWithOffsetDays(2)
        )}
        else{
          this.$message.warning(  '17:00（不包括17:00）前定价设置次日生效，当前日期'+
          this.getDateWithOffsetDays(0) +
          '生效日期将改为'+ this.getDateWithOffsetDays(1))
        }
       
      }
      this.$http
        .post(url, {
          ...params,
          reviewersStatus: status,

          // windCity: this.dataForm.windCity.join('|')
        })
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg);
          }
          this.$message({
            message: this.$t("prompt.success"),
            type: "success",
            duration: 500,
            onClose: () => {
              this.visible = false;
              this.getDataList();
            },
          });
        })
        .catch(() => {});
    },
    getDateWithOffsetDays(days) {
      var now = new Date();
      now.setDate(now.getDate() + days); // 偏移指定天数

      var year = now.getFullYear();
      var month = now.getMonth() + 1; // 月份从 0 开始，需要加 1
      var date = now.getDate();

      // 返回格式为 YYYY-MM-DD 的日期字符串
      return year + "-" + this.padZero(month) + "-" + this.padZero(date);
    },
    // 判断时间是否选的次日超过下午五点
    isNextDayAfter5pm(hour = 17) {
        let now = new Date();
        var currentHour = now.getHours();
       
        return currentHour >= hour;
     
    },

    // 辅助函数：将数字补零成两位数
    padZero(num) {
      if (num < 10) {
        return "0" + num;
      } else {
        return num.toString();
      }
    },
  },
  components: {
    AddOrUpdate,
    sclectCity: city,
    renSelect,
  },
};
</script>
<style scoped lang="scss">
.messageText {
  padding: 2px 10px;
  font-weight: 400;
  font-style: normal;
  color: #d9001b;
  text-align: center;
  background: #f5debc;
  width: 1000px;
  font-size: 16px;
  & :nth-child(1) {
    font-weight: 900;
  }
}
</style>

